import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function WhoThisIsFor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forYou = ['Mujeres de 45+ que se despiertan sistemáticamente entre las 2 AM y las 4 AM.', 'Latinas trabajadoras en USA que necesitan energía real para cumplir con su día.', 'Mujeres que sufren de sofocos nocturnos o "calores" que interrumpen su descanso.', 'Quienes están cansadas de sentirse irritables y agotadas por la falta de sueño crónico.'];
  const notForYou = ['Personas que buscan una "pastilla mágica" para no hacer ningún cambio en su rutina.', 'Quienes no están dispuestas a ajustar la temperatura de su habitación o sábanas.', 'Hombres (este protocolo está diseñado específicamente para el sistema endocrino femenino).'];
  return <section ref={ref} className="w-full bg-[#1e293b] text-white py-20 md:py-32" data-id="element-186">
      <div className="max-w-6xl mx-auto px-6" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-16" data-id="element-188">
          {/* For You */}
          <div className="space-y-8" data-id="element-189">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white text-center" data-id="element-190">
              Esto Es Para Ti Si...
            </h2>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-191">
              {forYou.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              delay: index * 0.1,
              duration: 0.6
            }} className="flex gap-4 items-start bg-[#0f172a] p-6 rounded-lg" data-id="element-192">
                  <CheckCircle2Icon className="w-6 h-6 text-[#d4a853] flex-shrink-0 mt-1" data-id="element-193" />
                  <p className="text-gray-300 leading-relaxed" data-id="element-194">{item}</p>
                </motion.div>)}
            </div>
          </div>

          {/* Not For You */}
          <div className="space-y-8" data-id="element-195">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white text-center" data-id="element-196">
              Esto NO Es Para Ti Si...
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
              {notForYou.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {
              opacity: 0,
              x: -20
            }} transition={{
              delay: index * 0.1,
              duration: 0.6
            }} className="flex gap-4 items-start bg-[#0f172a] p-6 rounded-lg border-l-4 border-red-500" data-id="element-198">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-199" />
                  <p className="text-gray-300 leading-relaxed" data-id="element-200">{item}</p>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}